var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("申请服务单号:")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _vm._v(_vm._s(_vm.servcReqVoucher.no))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("零售商名称:")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _vm._v(_vm._s(_vm.servcReqVoucher.buyerComName))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("联系电话:")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _vm._v(_vm._s(_vm.servcReqVoucher.buyerShopContactTel))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "graphic-info" }, [
        _c("div", { staticClass: "graphic-item" }, [
          _c("div", { staticClass: "image-info" }, [
            _c("img", { attrs: { src: _vm.servcReqVoucher.servcBrowseUrl } })
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "text-info",
              staticStyle: { "padding-left": "146px" }
            },
            [
              _c("p", { staticClass: "name font14" }, [
                _c("span", { staticClass: "mr10" }, [_vm._v("服务号")]),
                _vm._v(" "),
                _c("span", { staticClass: "value font-gray3" }, [
                  _vm._v(_vm._s(_vm.servcReqVoucher.svcNo || "无"))
                ])
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "model" }, [
                _c("span", { staticClass: "mr10" }, [_vm._v("机构地址")]),
                _vm._v(" "),
                _c("span", { staticClass: "value font-gray3" }, [
                  _vm._v(_vm._s(_vm.servcReqVoucher.buyerShopAddr))
                ])
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "num" }, [
                _c("span", { staticClass: "mr10" }, [_vm._v("备注")]),
                _vm._v(" "),
                _c("span", { staticClass: "value font-red" }, [
                  _vm._v(_vm._s(_vm.servcReqVoucher.requestDesc || "无"))
                ])
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        { staticClass: "demo-ruleForm", attrs: { model: _vm.servcReqVoucher } },
        [
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title required" }, [
              _vm._v("请选择指派方:")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "servicerComName" } },
                  [
                    _c("swb-org-tree", {
                      ref: "swb_org_tree",
                      attrs: {
                        isShowIcon: false,
                        enableSearch: true,
                        isRadio: true
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5cf6c8ac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cf6c8ac","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/servcReq/ServcReqAppointStore.vue
// module id = 2092
// module chunks = 1